// src/components/SkeletonLoader.jsx
import React from 'react';
import './SkeletonLoader.css'; // Vamos criar este CSS

const SkeletonLoader = ({ type = 'list-item' }) => {
  if (type === 'card') {
    return (
      <div className="skeleton-card">
        <div className="skeleton-line title"></div>
        <div className="skeleton-line"></div>
        <div className="skeleton-line short"></div>
      </div>
    );
  }

  return (
    <div className="skeleton-list-item">
      <div className="skeleton-avatar"></div>
      <div className="skeleton-text-group">
        <div className="skeleton-line"></div>
        <div className="skeleton-line short"></div>
      </div>
    </div>
  );
};

export default SkeletonLoader;